import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';
import LoadSalesJv from './functions/loadSalesJv';
import CustomerForm from '../customer/customerForm';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';


import InvoiceInfo from './steps/invoiceInfo';
import InvoiceAccount from './steps/invoiceAccount';
import InvoiceCart from './steps/invoiceCart';
import InvoiceCharge from './steps/invoiceCharge';
import InvoiceTotal from './steps/invoiceTotal';
import InvoiceJv from '../../components/journalVoucher/invoiceJv';
import InvoicePayment from './steps/invoicePayment';

const InvoiceForm = (props) => {

    const { api, userData, settingData, accountData, warehouseData, companyId, defaultCurrency, rateToMainCurrency, rateMainToSecondaryCurrency,
        productData, refData, branchData, salableData, yearId, sessionId, currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, isOrder, isDebit, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [journalVoucher, setJournalVoucher] = useState({});
    const [cart, setCart] = useState([])
    const [charges, setCharges] = useState([])
    const [transactions, setTransactions] = useState([])

    const [showAddAccountModal, setShowAddAccountModal] = useState(false);

    const openAddAccountModal = (e) => {
        setShowAddAccountModal(!showAddAccountModal);
    }

    const refAddedAccount = async () => {
        try {
            setIsLoading(true);
            const dataArray = ['auxAccount']
            await refData(dataArray, companyId);
            setIsLoading(false);
        } catch (error) {
            console.error('Error refreshing data Contact Support');
        }
    };

    const subTotal = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.totalPrice), 0);
    const cartDiscounts = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.priceDiscountAmount), 0);

    let discountAmount;
    if (journalVoucher.discountType == 'amount') {
        discountAmount = journalVoucher.discountAmount;
    } else {
        discountAmount = (journalVoucher.discountPercentage / 100) * (subTotal);
    }

    let discountPercentage;
    if (journalVoucher.discountType == 'percentage') {
        discountPercentage = journalVoucher.discountPercentage;
    } else {
        discountPercentage = (discountAmount / (subTotal)) * 100 || 0;
    }

    const totalDiscounts = parseFloat(discountAmount);
    const total = subTotal - discountAmount;

    const vate = cart.reduce((sum, item) => sum + parseFloat(item.vatAmount), 0);
    const vat = vate - (vate * (journalVoucher.discountPercentage / 100)) || 0;

    const netCharges = charges.reduce((sum, item) => sum + parseFloat(item.total), 0);

    const netTotal = parseFloat(total) + parseFloat(vat) + parseFloat(netCharges);

    const today = new Date().toISOString().split('T')[0];

    const selectedCurrency = currencyData?.find(option => option.id === journalVoucher.currencyId);

    const cartItem = {
        accountId: '',
        index: 0,

        quantity: 1,
        freeQuantity: 0,
        netQuantity: 1,

        cost: 0,

        price: 0,
        priceDiscountPercentage: 0,
        priceDiscountAmount: 0,
        netPrice: 0,

        details: '',

        unitName: '',
        unitQuantity: '',

        vatPercentage: 0,
        vatAmount: 0,
        productId: '',
    };


    // idRow Change
    useEffect(() => {

        if (!isLoading) {
            setCartAndUnits();
            setTransactions(idRow?.transactions || [])
            setCharges(idRow?.charges || [])

            setJournalVoucher(
                {
                    createdBy: createdBy,
                    sessionId: sessionId,
                    companyId: companyId,
                    yearId: yearId,
                    accountId: idRow?.accountId || null,
                    refNumber: idRow?.refNumber || '',
                    date: idRow?.date || today,
                    type: type,
                    totalDebit: idRow?.totalDebit || subTotal,
                    totalCredit: idRow?.totalCredit || subTotal,
                    secondaryTotalDebit: idRow?.secondaryTotalDebit || 0,
                    secondaryTotalCredit: idRow?.secondaryTotalCredit || 0,
                    details: idRow?.details || '',
                    paymentType: idRow?.paymentType || 'cash',
                    downPayment: idRow?.downPayment || 0,
                    isDebit: idRow?.isDebit || isDebit,
                    isOrder: idRow?.isOrder || isOrder,
                    discountType: idRow?.discountType || 'percentage',
                    discountPercentage: idRow?.discountPercentage || 0,
                    discountAmount: idRow?.discountAmount || 0,
                    currencyId: idRow?.currencyId || defaultCurrency?.id,
                    rate: idRow?.rate || defaultCurrency?.rate,

                    warehouseId: idRow?.warehouseId || userRole?.warehouseId,
                    projectId: idRow?.projectId || userRole?.projectId,
                    branchId: idRow?.branchId || userRole?.branchId,
                }
            )
        }
    }, [isLoading]);

    const setCartAndUnits = () => {
        const updatedCart = idRow?.cart ? [...idRow?.cart] : [];
        for (const item of updatedCart) {
            const product = salableData.find(e => e.id == item.productId);
            const units = product?.units || [];
            item.units = units;
        }
        setCart(updatedCart || [cartItem])
    }


    const totalCost = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.cost) * (currentItem?.netQuantity), 0);
    const totalPrice = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.netPrice), 0);
    const totalProfit = totalPrice - (totalCost + journalVoucher.discountAmount);




    // change totalDebit and totalCredit
    useEffect(() => {

        const totalDebit = rateToMainCurrency(selectedCurrency, netTotal);
        const totalCredit = rateToMainCurrency(selectedCurrency, netTotal);

        const cost = rateToMainCurrency(selectedCurrency, totalCost);
        const profit = rateToMainCurrency(selectedCurrency, totalProfit);

        setJournalVoucher((prev) => ({
            ...prev,
            cost: cost,
            profit: profit,
            secondaryCost: rateMainToSecondaryCurrency(cost),
            secondaryProfit: rateMainToSecondaryCurrency(profit),
            debit: netTotal,
            credit: netTotal,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalCredit: rateMainToSecondaryCurrency(totalDebit),
            secondaryTotalDebit: rateMainToSecondaryCurrency(totalCredit),
        }));

    }, [netTotal]);



    useEffect(() => {
        if (showModal) {
            fetchData();
        } else {
            setIsLoading(true);
        }
    }, [showModal]);


    
    const fetchData = async () => {
        try {
            const dataArray = ['auxAccount', 'warehouse', 'branch', 'project', 'currency', 'salable', 'setting']
            await refData(dataArray, companyId);
            setIsLoading(false);
        } catch (error) {
            console.error('Error refreshing data Contact Support');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        const form = document.getElementById('form');

        if (form.checkValidity() === false) {
            return;
        }

        if (cart.length < 1) {
            toast.error('cart is empty')
            return;
        }

        if (transactions.length < 2) {
            toast.error('you need at least 2 transactions')
            return;
        }


        setLoadingEffect(true);


        const data = {
            userId: userData.id,
            sessionId,
            jvId: idRow?.id,
            transactions,
            journalVoucher,
            cart,
            charges,
        }

        const operation = idRow ? 'edit' : 'add'
        try {
            let res = await api.post(`journalVoucher/${operation}`, data);

            if (res.data.status) {
                toast.success(res.data.message);
                closeModal();
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }

    const closeModal = () => {
        toggleModal();
        setValidated(false);
        const form = document.getElementById('form');
        form.reset();
        setCart([cartItem]);
        setTransactions([]);
        setCharges([]);
        refreshTable();
    }



    return (
        <>
            <Modal show={showModal} fullscreen={true} onHide={toggleModal}>

                <Modal.Header closeButton>
                    <Modal.Title>{idRow ? 'Edit ' : 'Add '}{type}</Modal.Title>
                </Modal.Header>

                {isLoading &&
                    <Loader />
                }

                {!isLoading &&
                    <Modal.Body style={{ backgroundColor: '#f0f2f5' }}>
                        <Form validated={validated} id={'form'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >

                            <Row className="mb-4">
                                <Col>
                                    <Card title="Customer" bordered={false}>
                                        <InvoiceAccount
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                            openAddAccountModal={openAddAccountModal}
                                        />
                                    </Card>
                                </Col>

                                <Col>

                                    <Card title="Details" bordered={false}>
                                        <InvoiceInfo
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Col>
                                    <Card title="Products" bordered={false}>
                                        <InvoiceCart
                                            cart={cart}
                                            setCart={setCart}
                                            cartItem={cartItem}
                                            selectedCurrency={selectedCurrency}
                                            setJournalVoucher={setJournalVoucher}
                                            idRow={idRow}
                                        />
                                    </Card>
                                </Col>
                            </Row>


                            <Row className="mb-4">
                                <Col>
                                    <Space direction="vertical" size="large" style={{ width: "100%" }}>
                                        <Card title="Charges" bordered={false}>
                                            <InvoiceCharge
                                                charges={charges}
                                                setCharges={setCharges}
                                                selectedCurrency={selectedCurrency}
                                                validated={validated}
                                            />
                                        </Card>
                                        <Card title="Payment" bordered={false}>
                                            <InvoicePayment
                                                journalVoucher={journalVoucher}
                                                setJournalVoucher={setJournalVoucher}
                                                validated={validated}
                                            />
                                        </Card>
                                    </Space>
                                </Col>
                                <Col>
                                    <Card title="Total" bordered={false}>
                                        <InvoiceTotal
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            subTotal={subTotal}
                                            cartDiscounts={cartDiscounts}
                                            discountPercentage={discountPercentage}
                                            discountAmount={discountAmount}
                                            total={total}
                                            vat={vat}
                                            netCharges={netCharges}
                                            netTotal={netTotal}
                                            selectedCurrency={selectedCurrency}
                                        />
                                    </Card>
                                </Col>
                            </Row>



                            <Row className="mb-4">
                                <Col>
                                    <Card title="Journal Voucher" bordered={false}>
                                        <InvoiceJv
                                            transactions={transactions}
                                        />
                                    </Card>
                                </Col>
                            </Row>


                            <div style={{ textAlign: 'right' }}>
                                <Button type="primary" loading={loadingEffect} htmlType="submit"
                                    onClick={() => setValidated(true)}
                                    style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
                            </div>


                        </Form>
                    </Modal.Body>
                }
            </Modal >

            <LoadSalesJv
                setTransactions={setTransactions}
                cart={cart}
                journalVoucher={journalVoucher}
                selectedCurrency={selectedCurrency}
                netTotal={netTotal}
                totalDiscounts={totalDiscounts}
                vat={vat}
                netCharges={netCharges}
            />

        </>
    )
}


export default InvoiceForm;